export default __webpack_public_path__ + "static/media/lock1.cf7b1aef.jpg";